module.exports = __webpack_public_path__ + "53e3d15f927c995c41e60dff8b8d8099.woff2";